import axios from "axios";
import Utility from "../../../shared/utility";
import { store } from "../../../state-management/state-mgmt";
export default {
  postBusinessData(obj) {
    let call = "post";
    return this.getData("/co/business_getbyId", call, obj);
  },

  getInboundData(call, pass, userId, salesOrderId, messageId) {
    return this.getData(`/so/so_order_api_in_out?Pass=${pass}&UserId=${userId}&so_key=${salesOrderId}&msg_id=${messageId}`, call);
  },

  getReturnAddData(call, userId, proj_key, searchTest, bu_id, obj, showMessage, disableLoader, pass) {
    return this.getData(
      `/so/so_rtn_address?UserId=${userId}&proj_key=${proj_key}&SearchStr=${searchTest}&bu_key=${bu_id}&Pass=${pass}`,
      call,
      obj,
      showMessage,
      disableLoader,
    );
  },

  postOrderTypeData(call, obj) {
    return this.getData("/so/so_order_types", call, obj);
  },

  getWarrentyData(call, userId) {
    return this.getData(`/so/so_warrantytype?UserId=${userId}`, call);
  },

  countryList(call) {
    return this.getData("/cp/country_state_details", call);
  },

  getOrderTypeData(call, userId, proj_key, so_id, isAddLine) {
    return this.getData(`/so/so_linetypelist?UserId=${userId}&ProjKey=${proj_key}&so_id=${so_id}&isAddLine=${isAddLine}`, call);
  },

  getSalesOrderDetails(call, userId, salesOrder) {
    return this.getData(`/so/so_get?UserId=${userId}&so_id=${salesOrder}`, call);
  },

  getSalesOrderPartialShipLineItem(call, userId, salesOrder) {
    return this.getData(`/so/so_partialship_line_item?UserId=${userId}&so_id=${salesOrder}`, call);
  },
  
  getSalesOrderPartialShipHistory(call, salesOrder, userId) {
    return this.getData(`/so/so_partialship_history?order_id=${salesOrder}&user_key=${userId}`, call);
  },
  
  postcarrierServiceLvlData(obj) {
    let call = "post";
    return this.getData("/so/so_service_levels", call, obj);
  },
  postCustomerData(call, obj, showMessage, disableLoader) {
    return this.getData("/co/customer_data", call, obj, showMessage, disableLoader);
  },

  postShipSearch(call, obj, showMessage, disableLoader) {
    return this.getData("/so/so_shippart_search", call, obj, showMessage, disableLoader);
  },

  postShipWareData(call, obj) {
    return this.getData("/so/so_ppid_validate", call, obj);
  },

  getLineItemData(call, userId, line_id) {
    return this.getData(`/so/so_lineitem_details?UserId=${userId}&line_id=${line_id}`, call);
  },

  postBuildData(call, obj, showMessage, disableLoader) {
    return this.getData("/so/so_buildpart_search", call, obj, showMessage, disableLoader);
  },

  postReturnSearch(call, obj, showMessage, disableLoader) {
    return this.getData("/so/so_returnpart_search", call, obj, showMessage, disableLoader);
  },

  addBookMark(call, userId, so_id, showMessage) {
    return this.getData(`/so/so_order_bookmark?UserId=${userId}&so_id=${so_id}&Pass=2`, call, "", showMessage);
  },
  postSoUpdate(call, obj, showMessage) {
    return this.getData("/so/so_order_update", call, obj, showMessage);
  },

  postSoDelete(call, obj, showMessage) {
    return this.getData("/so/so_order_actions_del_hld", call, obj, showMessage);
  },
  postSoShippingHold(call, obj, showMessage) {
    return this.getData("/so/so_order_shipping_hold", call, obj, showMessage);
  },
  postSoCancel(call, obj, showMessage) {
    return this.getData("/so/so_order_cancel", call, obj, showMessage);
  },

  getSalesOrderPickedData(call, so_id, line_id, user_id) {
    return this.getData(`/so/so_pick_details?so_key=${so_id}&line_item=${line_id}&UserId=${user_id}`, call, "");
  },

  getSalesOrderReceivedData(call, so_id, line_id, user_id) {
    return this.getData(`/so/so_receipt_details?so_key=${so_id}&line_item=${line_id}&UserId=${user_id}`, call, "");
  },

  getSalesOrderShippedData(call, so_id, line_id, user_id) {
    return this.getData(`/so/so_shipment_details?so_key=${so_id}&line_item=${line_id}&UserId=${user_id}`, call, "");
  },

  getSoLabelDetails(call, pass, sorecp_id, user_id, dir, solabel_id) {
    return this.getData(
      `/so/so_order_shipments_label_details?pass=${pass}&sorecp_id=${sorecp_id}&UserId=${user_id}&dir=${dir}&solabel_id=${solabel_id}`,
      call,
      "",
    );
  },

  getCommentsList(call, user_id, so_id) {
    return this.getData(`/so/so_order_comments?UserId=${user_id}&so_key=${so_id}`, call, "");
  },

  getSoTrackingWaybills(call, so_id) {
    return this.getData(`/so/so_tracking_waybills?SoKey=${so_id}`, call, "");
  },

  getSoTrackingWaybillHistory(call, so_id) {
    return this.getData(`/so/so_tracking_waybill_history?SoKey=${so_id}`, call, "");
  },

  async getData(url, call, obj, showMessage, disableLoader) {
    if (!disableLoader) {
      store.commit("ConfigModule/LoaderDialog", { visible: true, title: "Please Wait..." });
    }

    let res = {};
    try {
      res = call === "get" ? await axios.get(url) : await axios.post(url, obj);
    } catch (error) {
      if (error.response) {
        store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: error.response.data?.message,
        });
      }
      store.commit("ConfigModule/LoaderDialog", { visible: false });
      return { message: "NA" };
    }

    const responseBody = res?.data?.body;
    const responseMessage = responseBody?.data?.message ?? responseBody?.message;

    if (!responseMessage) {
      store.commit("ConfigModule/Alert", {
        type: "error",
        isShow: true,
        message: "No Data Available",
      });
      store.commit("ConfigModule/LoaderDialog", { visible: false });
      return { message: "NA" };
    }

    try {
      const parsedMessage = JSON.parse(responseMessage);
      if (showMessage) {
        store.commit("ConfigModule/Alert", {
          type: "success",
          isShow: true,
          message: parsedMessage?.Result?.[0]?.Message,
        });
      }
      store.commit("ConfigModule/LoaderDialog", { visible: false });
      return parsedMessage;
    } catch (err) {
      store.commit("ConfigModule/Alert", {
        type: "error",
        isShow: true,
        message: Utility.apiError(err),
      });
      return { message: "NA" };
    }
  },
};
